package com.routexk.quiz

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.key
import com.routexk.quiz.di.ProvideAppContainer
import com.routexk.quiz.ui.localization.ProvideLanguage
import com.routexk.quiz.ui.localization.rememberLanguage
import com.routexk.quiz.ui.theme.AppColors
import com.routexk.quiz.ui.theme.initAppTheme
import com.routexk.quiz.utils.OAuthHelper
import com.routexk.quiz.utils.Storage
import com.routexk.quiz.utils.StorageKeys
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.breakpoint.BreakpointSizes
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

@InitSilk
fun initSilk(ctx: InitSilkContext) {

    val savedTheme = try {
        Storage.get(StorageKeys.THEME)
    } catch (_: Exception) { null }
    ctx.config.initialColorMode = when (savedTheme) {
        "LIGHT" -> ColorMode.LIGHT
        "DARK" -> ColorMode.DARK
        else -> ColorMode.LIGHT
    }

    ctx.theme.breakpoints = BreakpointSizes(
        sm = 0.px,
        md = 768.px,
        lg = 1280.px,
        xl = 1920.px
    )

    initAppTheme(ctx)
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    LaunchedEffect(Unit) {
        com.routexk.quiz.analytics.Ga4.init()
        com.routexk.quiz.analytics.FbPixel.init()
        com.routexk.quiz.analytics.Clarity.init()
        // Reveal the app only after the first real (mobile-aware) frame is
        // painted, so phones never flash the desktop static pre-render. Double
        // rAF waits past the composition's DOM apply + paint.
        kotlinx.browser.window.requestAnimationFrame {
            kotlinx.browser.window.requestAnimationFrame {
                kotlinx.browser.document.documentElement?.classList?.add("app-ready")
            }
        }
        OAuthHelper.loadGoogleSDK {
            console.log("Google SDK loaded successfully")
        }
    }

    ProvideAppContainer {

        val languageState = rememberLanguage()

        key("silk-app") {
            SilkApp {
                ProvideLanguage(languageState) {
                    val colorMode = ColorMode.current
                    val colors = AppColors.getColors(colorMode)

                    Surface(
                        SmoothColorStyle.toModifier()
                            .minHeight(100.vh)
                            .scrollBehavior(ScrollBehavior.Smooth)
                            .backgroundColor(colors.background)
                            .color(colors.textPrimary)
                            .fontFamily("Inter", "sans-serif")
                    ) {
                        content()
                    }
                }
            }
        }
    }
}
